module.exports = __webpack_public_path__ + "img/Edit.db5bfd5d.svg";